export const PICKER_FALLBACK_COLOR = "#000000";
